import React from 'react';


import { useQuery } from "react-query";

// see : https://tanstack.com/query/latest/docs/react/guides/paginated-queries
// see:  https://tanstack.com/query/v3/docs/react/guides/paginated-queries

import { fetchDepotsGestionAdministration } from 'utils/queries';


import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import TablePagination from '@mui/material/TablePagination';


import Utilisateur from 'components/Shared/Utilisateur';

const AdministrationDepotsGestionTable = () => {

    const [page, setPage] = React.useState(0);
    const [nbParPage, setNbParPage] = React.useState(100);

    const [filtreCodeDepot, setFiltreCodeDepot] = React.useState('');
    const [filtreDenomination, setFiltreDenomination] = React.useState('');

    const { isLoading, isError, error, data } =
        useQuery({
            queryKey: [
                'depotsGestionTable',
                page,
                nbParPage,
                filtreCodeDepot,
                filtreDenomination
            ],
            queryFn: () => fetchDepotsGestionAdministration({
                page,
                nbParPage,
                filtreCodeDepot,
                filtreDenomination,
            }),
            keepPreviousData: true,
        })


    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setNbParPage(+event.target.value);
        setPage(0);
    };


    React.useEffect(() => {
            setPage(0);
        },
        [filtreCodeDepot, filtreDenomination]
    );



    return (
        <>
            <Typography gutterBottom variant="h5">
                Visualisation des dépots
            </Typography>


            {isLoading ? (
                <div>Chargement...</div>
            ) : isError ? (
                <div>Erreur: {error.message}</div>
            ) : (
                <span></span>
            )}

            <Paper>

                {data ? (
                    <TableContainer sx={{ maxHeight: 'calc(100vh - 152px)' }}>
                        <Table stickyHeader aria-label="sticky table" sx={{ width: '100%' }} size='small'>
                            <TableHead
                                sx={{
                                    position: "sticky",
                                    top: 0,
                                    zIndex: 1,
                                }}
                            >
                                <TableRow>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey', width: '30px' }}>Code</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Nom</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Gestionnaire</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Responsable</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Responsable région</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Adresse</TableCell>
                                    <TableCell sx={{ backgroundColor: 'lightslategrey' }}>Client cession</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        <TextField
                                            value={filtreCodeDepot}
                                            onChange={e => { setFiltreCodeDepot(e.target.value) }}
                                        >
                                        </TextField>
                                    </TableCell>
                                    <TableCell>
                                        <TextField
                                            value={filtreDenomination}
                                            onChange={e => { setFiltreDenomination(e.target.value) }}
                                        >
                                        </TextField>
                                    </TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {data.depotsGestion
                                    .map((depotGestion) => {

                                        //console.log(depotGestion);

                                        return (
                                            <TableRow hover key={`${depotGestion.codeDepot}`}>
                                                <TableCell>
                                                    {depotGestion.codeDepot}
                                                </TableCell>

                                                <TableCell>
                                                    {depotGestion.nom}
                                                </TableCell>

                                                <TableCell>
                                                    {depotGestion.gestionnaire ? <Utilisateur utilisateur={depotGestion.gestionnaire} format="chip" /> : ""}
                                                </TableCell>
                                                <TableCell>
                                                    {depotGestion.responsable ? <Utilisateur utilisateur={depotGestion.responsable} format="chip" /> : ""}
                                                </TableCell>
                                                <TableCell>
                                                    {depotGestion.responsableRegion ? <Utilisateur utilisateur={depotGestion.responsableRegion} format="chip" /> : ""}
                                                </TableCell>

                                                <TableCell>
                                                    {depotGestion.adresse}<br/>
                                                    {`${depotGestion.codePostal} ${depotGestion.ville}`}
                                                </TableCell>

                                                <TableCell>
                                                    {depotGestion.clientCession ? `${depotGestion.clientCession.code} - ${depotGestion.clientCession.libelle}` : ""}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>

                        </Table>
                        <TablePagination
                            rowsPerPageOptions={[10, 25, 100]}
                            component="div"
                            count={data.nbFiltres}
                            rowsPerPage={nbParPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </TableContainer>
                ) : <span>...</span>
                }

            </Paper>


        </>

        );

};





//AdministrationDepotsGestionTable.propTypes = {
//};

export default AdministrationDepotsGestionTable;